<template>
  <div class="seckill"
       v-show="seckillShow">
    <div class="seckill-top">
      <span :class="{'curr':changeInd == ind}" @click="change(ind)" v-for="(ite,ind) in changeButton" :key="ind">{{ite}}</span>
    </div>
    <div class="seckill-bottom">
      <div class="bottom-box-left"
         @contextmenu.stop.prevent=""
         v-show="window.innerWidth < 10 || window.innerWidth >= 768">
        <img :src="content.backImg"
            alt="">
        <img class="centers"
            :src="content.Img"
            alt="">
        <span class="texts">{{content.name}}</span>
      </div>
      <div class="bottom-box-right">
        <haowu :contentData="contentData"
              :blockData="blockData"
              @emitContextMenuItem="leftRightMove"
              @arrowRight='getSeckill'
              @seckillShow='seckillShow = false'></haowu>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../bus.js'
import moment from "moment";
import haowu from './haowutuijian.vue'
export default {
  name: 'seckill',
  components: {
    haowu,
    moment
  },
  data () {
    return {
      contentData: [],
      window: window,
      seckillShow: true,
      changeButton:['商户','平台方'],
      changeInd:0,
      dataType:''
    }
  },
  props: {
    blockData: Object,
    content: Object
  },
  mounted () {
    var num = 5;
    if ( window.innerWidth <= 768) {
      num = 2;
    }
    this.getSeckill(1, num);
  },
  methods: {
    change(ind){
      this.changeInd = ind;
      if(ind == 1){
        this.dataType = "1";
      }else{
        this.dataType = "";
      }
      var num = 5;
      if ( window.innerWidth <= 768) {
        num = 2;
      }
      this.getSeckill(1, num);
    },
    //左移右移
    leftRightMove (ind,ev) {
      const item = this.contentData[ind];
      window.$nodeId = item.nodeId;
      Bus.$emit('windowRight', ev, 'block');
      var left = {}, center = {}, right = {};
      if (item && item.contentId) {
        center = {
          item: item,
          blockId: item.blockId,
          contentId: item.contentId,
          contentShowRowsSort: ind,
          standardJson: item.tags
        }
      }

      var rightLeft = {
        left: left,
        center: center,
        right: right
      }
      window.$rightLeft = rightLeft;
    },
    getSeckill (size, num) {
      var url = '/zciid-deliverable/showPlatformStyle/flow/api/getDuctionContentByAppId.json',
      data={appId: this.$appId,pageNum: size,pageSize: num,types:this.content.ind,dataType:this.dataType}
      // if(this.memberLevel){
      //   url='/zciid-deliverable/showPlatformStyle/flow/api/getMemberContentByAppId.json',
      //   data={appId: this.$appId,pageNum: size,pageSize: num}
      // }
      //获取图片信息
      this.$http
        .get(url,data).then(res => {
          var _this = this;
          _this.contentData = [];
          if (res.state == 1 && res.data.length) {
            var array = [];
            res.data.forEach((item) => {
              var tags = [], pictures = [], others = [], btns = [], contentId = '', blockId = '';
              contentId = item.contentId;
              blockId = item.blockId;
              item.standardJson.forEach((ele) => {
                if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                  pictures.push(ele.standardData);
                } else {
                  others.push(ele);
                }
              })

              array.push({
                appId:item.appId,
                contentId: contentId,
                blockId: blockId,
                nodeId: item.nodeId,
                pictures: pictures,
                others: others,
                btns: btns,
                sign: item.sign,
                tags: item.standardJson,
                endTime: item.endTime,
                appName:item.appName,
                discountTypes: item.discountTypes,
                priceType: item.priceType,
                changeData: item.changeData,
                spellData: item.spellData,
                spellText: item.spellText,
                giveData: item.giveData,
                giveText: item.giveText,
                ordinaryPrice: item.ordinaryPrice,
                silverPrice: item.silverPrice,
                goldprice: item.goldprice,
                platinumPrice: item.platinumPrice,
                diamondsPrice: item.diamondsPrice,
                blackGoldprice: item.blackGoldprice,
                memberEndTime: item.memberEndTime
              })
            })
            _this.contentData.push(...array);
          }else if(size == 1){
            _this.contentData = [];
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.seckill .seckill-top{
  width: 100%;
  margin-top: 10px;
  span{
    display: inline-block;
    width: 120px;
    height: 36px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    color: #333;
    background-color: #efefef;
    border-top: 2px solid #efefef;
    border-bottom: 2px solid #efefef;
    box-sizing: border-box;
    cursor: pointer;
  }
  span:nth-child(2){
    margin-left: 5px;
  }
  .curr{
    background-color: #fff;
    border-top: 2px solid #2f8eed;
    border-bottom: 2px solid #fff;
  }
}
.seckill .seckill-bottom {
  margin-top: 16px;
  display: flex;
}
.seckill .bottom-box-left {
  position: relative;
  display: flex;
  height: 252px;
  width: 184px;
  .texts {
    position: absolute;
    left: 38px;
    top: 50px;
    font-size: 26px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #fff;
  }
  .centers {
    position: absolute;
    left: 72px;
    top: 126px;
  }
}
.seckill .bottom-box-right {
  margin-left: 10px;
  height: 252px;
  width: 1000px;
}
@media screen   and (max-width: 768px) {
  .seckill .bottom-box-right {
    width: 100%;
    margin-left: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/seckill.vue